import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaperPlane = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5662 2.17508C17.8818 2.39379 18.0474 2.77183 17.9881 3.14988L15.988 16.1472C15.9412 16.4502 15.7568 16.7158 15.488 16.8658C15.2193 17.0158 14.8974 17.0345 14.613 16.9158L10.8755 15.363L8.7348 17.6781C8.45668 17.9812 8.01917 18.0812 7.63479 17.9312C7.25041 17.7812 7.0004 17.4094 7.0004 16.997V14.3851C7.0004 14.2601 7.04728 14.1414 7.13165 14.0507L12.3692 8.33631C12.5505 8.13947 12.5442 7.83641 12.3567 7.64895C12.1692 7.46149 11.8661 7.44899 11.6692 7.62708L5.31288 13.2728L2.55346 11.8918C2.2222 11.7262 2.0097 11.395 2.00033 11.0264C1.99095 10.6577 2.1847 10.314 2.50346 10.1297L16.5037 2.13134C16.8381 1.94076 17.2506 1.9595 17.5662 2.17508Z",
		fill: "#0D2976"
	})
});
export default SvgPaperPlane;
